import { useHightouchBillingQueryContext } from 'modules/billing/contexts/HightouchBillingQueryContext';
import { yesterdayDisplay } from 'modules/billing/utils';
import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { isDefined } from 'utils/tsHelpers';
import { LoadingCard } from '../LoadingCard';
import { SmartIngestMetricTile } from '../MetricTile';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import { Container, Header, MainContent, Marquee, Title } from '../styled';
import { SMART_INGEST_CARD_IDS, SMART_INGEST_CARD_TEXT } from './constants';

const StyledContent = styled(MainContent)`
  padding-right: ${spacing.plusHalf};
  padding-left: ${spacing.plusHalf};
`;

const {
  cardTitle,
  productionSyncsCountLabel,
  productionSyncsTooltip,
  projectBreakdownUrl,
  testSyncsCountLabel,
  testSyncsTooltip,
  warningBannerText,
} = SMART_INGEST_CARD_TEXT;

export const SmartIngestCard = () => {
  const { hightouchOrg, isHightouchEnabled, isLoading } = useHightouchBillingQueryContext();
  const { allotment, productionSyncsCount, testSyncsCount } = hightouchOrg?.organization ?? {};

  if (!isHightouchEnabled) {
    return <></>;
  }

  const isOrgDefined = isDefined(hightouchOrg);
  const isProductionCountDefined = isDefined(productionSyncsCount);

  const isWarning =
    isOrgDefined && (productionSyncsCount ?? 0) >= hightouchOrg.organization.allotment;

  return isLoading ? (
    <LoadingCard />
  ) : (
    <Container data-test={SMART_INGEST_CARD_IDS.cardId}>
      <Header>
        <Title>{cardTitle}</Title>
        <div>
          <ProjectBreakdownLink to={projectBreakdownUrl} />
        </div>
      </Header>
      <Marquee>
        <SmartIngestMetricTile
          label={productionSyncsCountLabel}
          tooltip={productionSyncsTooltip}
          caption={isProductionCountDefined ? `As of ${yesterdayDisplay()}` : ''}
          value={productionSyncsCount}
          secondaryValue={allotment}
        />
        <SmartIngestMetricTile
          label={testSyncsCountLabel}
          tooltip={testSyncsTooltip}
          caption={isProductionCountDefined ? `As of ${yesterdayDisplay()}` : ''}
          value={testSyncsCount}
        />
      </Marquee>
      {isWarning && (
        <StyledContent>
          <WarningBanner isSubtle>{warningBannerText}</WarningBanner>
        </StyledContent>
      )}
    </Container>
  );
};
